export const CO_REQUEST_STATUSES = {
  'NEW': 1,
  'IN PROGRESS': 2,
  'READY': 3,
  'CLOSED': 0,
}